// 自动导入所有 svg 图标
const req = require.context('@/assets/svgs', false, /\.svg$/)
const requireAll = (requireContext) => requireContext.keys().map(requireContext)
requireAll(req)

import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'

// 注册为全局组件
Vue.component('mpm-svg', SvgIcon)
